var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('i',{staticClass:"ion ion-file-tray-outline not-found__icon"}),_c('p',{staticClass:"not-found__text"},[_vm._v("No data were found.")])])
}]

export { render, staticRenderFns }